import React from "react";

const SobreFooter = () => {
  return (
    <footer className="bg-luxury-champagne/40 py-16 relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent"></div>

      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/a68d70c6b66064870b0e9282c113321b.jpeg"
                alt="Carta do Eu Futuro"
                className="w-24 h-24 object-contain"
              />
              <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-luxury-charcoal">
                Carta do Eu Futuro
              </h3>
            </div>
            <p className="font-['Montserrat'] text-xs text-luxury-charcoal/40 leading-relaxed tracking-wide font-light">
              Uma experiência transformadora de autoconhecimento e planejamento
              emocional baseada em PNL.
            </p>
          </div>

          <div>
            <h4 className="font-['Montserrat'] font-semibold text-xs uppercase tracking-[0.2em] text-luxury-charcoal mb-5">
              <a
                href="#"
                className="hover:text-gold-600 transition-colors cursor-pointer"
              >
                Links Rápidos
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Início
                </a>
              </li>
              <li>
                <a
                  href="/sobre"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Sobre Nós
                </a>
              </li>
              <li>
                <a
                  href="/dashboard"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Minhas Cartas
                </a>
              </li>
              <li>
                <a
                  href="/faq"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Perguntas Frequentes
                </a>
              </li>
              <li>
                <a
                  href="/comunidade"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Comunidade
                </a>
              </li>
              <li>
                <a
                  href="/privacidade"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a
                  href="/termos"
                  className="font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
                >
                  Termos de Uso
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Montserrat'] font-semibold text-xs uppercase tracking-[0.2em] text-luxury-charcoal mb-5">
              Conecte-se
            </h4>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/bia.holmes"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 rounded-lg border border-gold-500/20 hover:border-gold-500 hover:bg-gradient-to-br hover:from-gold-500 hover:to-gold-700 flex items-center justify-center transition-all duration-300 cursor-pointer text-luxury-charcoal/40 hover:text-white"
                aria-label="Instagram @bia.holmes"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg border border-gold-500/20 hover:border-gold-500 hover:bg-gradient-to-br hover:from-gold-500 hover:to-gold-700 flex items-center justify-center transition-all duration-300 cursor-pointer text-luxury-charcoal/40 hover:text-white"
                rel="nofollow"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg border border-gold-500/20 hover:border-gold-500 hover:bg-gradient-to-br hover:from-gold-500 hover:to-gold-700 flex items-center justify-center transition-all duration-300 cursor-pointer text-luxury-charcoal/40 hover:text-white"
                rel="nofollow"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
            <a
              href="https://www.instagram.com/bia.holmes"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 font-['Montserrat'] text-xs text-luxury-charcoal/40 hover:text-gold-600 transition-colors mt-3 cursor-pointer tracking-wide"
            >
              <i className="ri-instagram-line text-gold-600 text-sm"></i>
              @bia.holmes
            </a>
            <p className="font-['Montserrat'] text-xs text-luxury-charcoal/40 mt-4 tracking-wide">
              <i className="ri-mail-line mr-2 text-gold-600"></i>
              contato@cartafuturo.org
            </p>
          </div>
        </div>

        <div className="border-t border-gold-500/15 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-['Montserrat'] text-xs text-luxury-charcoal/30 tracking-wide">
              © 2025 Carta do Eu Futuro. Todos os direitos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-['Montserrat'] text-xs text-luxury-charcoal/30 hover:text-gold-600 transition-colors cursor-pointer tracking-wide"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SobreFooter;
